<script setup lang="ts">
import Button from "./Button.vue";
import { toast } from "../composables/feedback";
import { session } from "../composables/session";
import { t } from "../i18n";

/** The ten recovery codes, shown once, to copy or download before going on. */
const props = defineProps<{ codes: string[] }>();
const emit = defineEmits<{ done: [] }>();

async function copy() {
  try {
    await navigator.clipboard.writeText(props.codes.join("\n"));
    toast(t("account.mfa.codes_copied"));
  } catch {
    toast(t("common.error"));
  }
}
function download() {
  const text = [
    t("account.mfa.codes_file_title", { email: session.me?.user.email ?? "" }),
    "",
    ...props.codes,
    "",
    t("account.mfa.codes_hint"),
  ].join("\n");
  const url = URL.createObjectURL(new Blob([text], { type: "text/plain" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "donetalk-codigos-de-recuperacao.txt";
  a.click();
  URL.revokeObjectURL(url);
}
</script>
<template>
  <section class="account-section">
    <h3>{{ t("account.mfa.codes_title") }}</h3>
    <p class="small">{{ t("account.mfa.codes_lead") }}</p>
    <ol class="recovery-codes">
      <li v-for="c in codes" :key="c">
        <code>{{ c }}</code>
      </li>
    </ol>
    <div class="row account-actions">
      <Button variant="secondary" compact @click="copy">{{
        t("account.mfa.copy")
      }}</Button>
      <Button variant="secondary" compact @click="download">{{
        t("account.mfa.download")
      }}</Button>
      <span class="grow" />
      <Button compact @click="emit('done')">{{ t("account.mfa.done") }}</Button>
    </div>
  </section>
</template>
